exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    background-color: #eff0f2;\n    bottom: 0;\n    display: table;\n    position: fixed;\n    right: 0;\n    width: 100%;\n}\n\nli {\n    display: table-cell;\n    text-align: center;\n    border-color: #111111;\n    width: 30%;\n    padding: 2vh;\n  }\n\n\nli a {\n    display: block;\n    color: black;\n    text-align: center;\n    text-decoration: none;\n\n}\n\n\n\nul li:first-child {\n    text-align: left;\n    border-right: 1px solid #369;\n}\n\nul li:last-child {\n    text-align: right;\n    border-left: 1px solid #369;\n}\n\n.fa {\n  color: #369;\n  font-size: 4.5vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/nav/nav-bottom/nav-bottom.component.css
// module id = ../../../../../src/app/nav/nav-bottom/nav-bottom.component.css
// module chunks = main